module.exports = __webpack_public_path__ + "img/homeBanner4.c5413bc1.png";